import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AdmissionsManagerService } from '../admissions-manager.service';
import { AdmissionsManagerSankeyFlowViewPart } from './sankey-flow/sankey-flow-view.part';
import { AdmissionsStatusViewPart } from './status/status-view.part';
import { AdmissionsTrimesterSwitchoverViewPart } from './trimester-switchover/trimester-switchover-view.part';

@Component({
	selector: 'admissions-manager-views-part',
	standalone: true,
	imports: [
		AdmissionsManagerSankeyFlowViewPart,
		AdmissionsStatusViewPart,
		AdmissionsTrimesterSwitchoverViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './manager-views.part.html',
})
export class AdmissionsManagerViewsPart implements OnInit {

	public service = inject(AdmissionsManagerService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}
